export const isCustomDisplayTextLabelPart = (part) => {
    return typeof part === 'object';
};
